const headCells = [
	/*{
		id: 'catalog',
		label: 'catalog.tableHeaders.ean'
	},
    */
	{
		id: 'author',
		label: 'catalog.tableHeaders.author'
	},
	{
		id: 'title',
		label: 'catalog.tableHeaders.title',
		sx: { width: '250px' }
	},
	{
		id: 'publisher',
		label: 'catalog.tableHeaders.publisher'
	},
	{
		id: 'price',
		label: 'catalog.tableHeaders.price'
	},
	{
		id: 'depot',
		label: 'catalog.tableHeaders.depot',
		sx: { width: '100px' }
	},
	{
		id: 'expirationDate',
		label: 'orders.deletionDate',
		sx: { width: '115px' }
	},

	{
		id: 'sapId',
		label: 'orders.sapIdRow'
	},

	{
		id: 'requestQty',
		label: 'catalog.tableHeaders.requestQty',
		sx: { textAlign: 'center', width: '80px' }
	},

	{
		id: 'evadibleQty',
		label: 'catalog.tableHeaders.evadibleQty',
		//label: 'catalog.tableHeaders.evadibleQtyOnTot',
		sx: { textAlign: 'center' }
	},
	{
		id: 'newsItem',
		label: 'catalog.tableHeaders.newsItem'
	},
	{
		id: 'slaDesc',
		label: 'catalog.tableHeaders.info'
	},
	{
		id: 'notes',
		label: 'catalog.tableHeaders.note'
	}
];

export default headCells;
